<template>


  <div id="property-management" class="flex flex-wrap-reverse items-center data-list-btn-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />


    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="restaurantlist">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ restaurantlist.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : restaurantlist.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="code">ID</vs-th>
        <vs-th sort-key="type">Image</vs-th>
        <vs-th sort-key="type">Restaurant Name</vs-th>
        <vs-th sort-key="type">Name</vs-th>
        <vs-th sort-key="type">Lastname</vs-th>
        <vs-th sort-key="active">E-mail</vs-th>
        <vs-th sort-key="active">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.id }}</p>
          </vs-td>

          <vs-td class="img-container">
            <img :src="tr.photoUrl" class="product-img" />
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.user_property["Restaurant-Name"] | title }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.name | title }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.last_name | title }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.email | title }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ getStatus(tr.open) | title }}</p>
            <vs-switch vs-type="success" @input="statusChange(tr, $event)" v-model="tr.open"/>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="CopyIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="duplicateData(tr)" />
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="editData(tr)" />
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>

  </div>

</template>

<script>

import DataViewSidebar from './DataViewSidebar'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      switchArray:['0', '1'],
      addNewDataSidebar: false,
      sidebarData: {},
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      user_group: 1
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.user_group !== ''
    },
    restaurantlist () {
      return JSON.parse(JSON.stringify(this.$store.state.api.restaurantlist))
    },
    properties () {
      return this.$store.state.api.properties
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.restaurantlist.length
    }
  },
  mounted () {
    this.user_group = 2
    this.propertyList(this.user_group)
    this.getUserList(this.user_group)
  },
  methods: {
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val

      if (val === false) {
        this.getUserList(this.user_group)
        this.$store.dispatch('api/setPropertyListForUser', {})
      }
    },
    statusChange (restaurant, event) {

      const obj = {
        restaurant_id: restaurant.id,
        type: (event) ? 'start' : 'stop'
      }

      this.$store.dispatch('api/setRestaurantStatus', obj).then(() => {
        this.getUserList(this.user_group)
        this.$vs.notify({
          title: 'Success',
          text: 'Item updated succesfully',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success'
        })
      }).catch(err => { console.error(err) })
    },
    getStatus (active) {
      if (active === 1) {
        return 'Open'
      } else {
        return 'Closed'
      }
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        clickNotClose: true,
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    deleteData (id) {

      this.openConfirm(() => {
        const obj = {
          user_id: id,
          user_group: this.user_group
        }
        this.$store.dispatch('api/removeUser', obj).then(() => {
          this.getUserList(this.user_group)
          this.$vs.notify({
            title: 'Delete',
            text: 'Item deleted succesfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }).catch(err => { console.error(err) })
      }, () => {

      })
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.add = true
      this.sidebarData.user_group = this.user_group
      this.sidebarData.propertyList = this.properties
      this.toggleDataSidebar(true)
    },
    duplicateData (data) {
      data.duplicating = true
      data.duplicating_id = data.id
      data.id = null
      this.sidebarData = data
      this.sidebarData.add = true
      this.sidebarData.user_group = this.user_group
      this.sidebarData.propertyList = this.properties
      this.toggleDataSidebar(true)
    },
    editData (data) {
      this.sidebarData = data
      this.sidebarData.user_group = this.user_group
      this.sidebarData.propertyList = this.properties
      this.toggleDataSidebar(true)
    },
    propertyList (group_id) {
      // Loading
      this.$vs.loading()

      const payload = {
        user_group: group_id
      }

      this.$store.dispatch('api/getPropertyList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getUserList (group_id) {
      // Loading

      const payload = {
        user_group: group_id
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUserList', payload)
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}

</script>

<style lang="scss">
  #property-management{
    .vs--single.vs--open .vs__selected{
      position: initial;
    }
    .vs-table-primary{
      width:100%;
    }
  }

  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 10px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
</style>
